module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-11-a7b80e1264ba39db75168eb73d647b31.jpg";